import React, {useState, useEffect, useMemo, useRef, useContext, createContext} from 'react';
import ErrorBoundary from './ErrorBoundary/ErrorBoundary';
import { classNames, deviceIsMd } from '../../Services/helpers';

const PageContext = createContext();

export const usePageContext = () => {
    return useContext(PageContext);
};


const Page = ({children, zeroPad, className, overflow}) => {
    const scrollRef = useRef(null);
    const [scrollTop, setScrollTop] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [offsetHeight, setOffsetHeight] = useState(window.innerHeight);
    const [offsetWidth, setOffsetWidth] = useState(window.innerWidth);


    const bars = useMemo(
        () => (document.getElementById('tab-container')?.offsetHeight ?? 92) + (document.getElementById('top-bar')?.offsetHeight ?? 53),
        []
    );

    useEffect(() => {
        if (!scrollRef?.current) {
            return;
        }

        const currentScrollRef = scrollRef.current;

        const listener = () => {
            setScrollTop(currentScrollRef.scrollTop);
            setScrollLeft(currentScrollRef.scrollLeft);
            setOffsetHeight(currentScrollRef.offsetHeight);
            setOffsetWidth(currentScrollRef.offsetWidth);
        }

        currentScrollRef.addEventListener('scroll', listener);

        return () => currentScrollRef.removeEventListener('scroll', listener);
    }, []);

    const providerValues = {
        scrollTop,
        scrollLeft,
        offsetHeight,
        offsetWidth,
    }

    return <PageContext.Provider value={providerValues}>
        <div ref={scrollRef}
            id="the-page"
            className={
                classNames(
                    'no-scroll-bar',
                    'relative flex flex-col w-full page-container bg-white z-20',
                    zeroPad ? '' : 'page-padding py-5',
                    overflow ? overflow : 'overflow-auto overscroll-y-contain',
                    className
                )
            }
            style={{
                maxHeight: deviceIsMd() ? `calc(100vh - 5rem)` : `calc(100vh - ${bars}px)`,
                minHeight: deviceIsMd() ? `calc(100vh - 5rem)` : `calc(100vh - ${bars}px)`,
            }}
        >
            <ErrorBoundary>
                {children}
            </ErrorBoundary>
        </div>
    </PageContext.Provider>
}

export default Page;
